module.exports = __webpack_public_path__ + "img/tomas.52ce3793.jpeg";